const userHasRight = (right) => {
    const currentUserRole = localStorage.getItem('userRole');
    const currentUserRights = localStorage.getItem('userRights');
    const allRights = currentUserRights ? JSON.parse(currentUserRights) : {};
    return currentUserRole == 'admin' || (allRights != null && allRights.hasOwnProperty(right) && allRights[right] == true);
}

export default userHasRight;